import { useEffect, useState } from 'react';
import fetchData from '../../../ApiPage';

const useCompetitionDetails = (eventId) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    const handleData = (payload) => {
      if (!isMounted) {
        return;
      }

      setData(Array.isArray(payload) ? payload : []);
      setLoading(false);
    };

    fetchData(handleData, eventId);

    return () => {
      isMounted = false;
    };
  }, [eventId]);

  return {
    data,
    loading,
  };
};

export default useCompetitionDetails;
